import Attendence from './Assets/Attendence.gif';
import dadJoke from './Assets/dadJoke.gif';
import Travel from './Assets/Travel.gif';
import GoogleDrive from './Assets/GoogleDrive.gif'

 const portfolioData = [
    {
        image: Attendence,
        link: "https://620b54a27fc54f60ca22864c--modest-thompson-231d72.netlify.app",
        githublink: "https://github.com/kewalb/attendence-portal-frontend",
        desc: "Attendence Portal",
        summary: "An attendence portal built to record the attendence of students by teachers. it's a simple project for now but more features will be added over time.",
        tech: "React | Node | Express | MongoDB"
    },

    {
        image: Travel,
        link: "https://6209e6afa90e6f9d0d1f6a59--relaxed-montalcini-d8a556.netlify.app",
        githublink: "https://github.com/kewalb/travel-recommendation",
        desc: "Travel Recommendation",
        summary: "This application shows all the restaurants, attractions and hotels in a specified location.",
        tech: "React | Google Maps | Axios | Material"
    },

    {
        image: dadJoke,
        link: "https://61fa422a5b6d3ed46da68968--reverent-hermann-38cad7.netlify.app",
        githublink: "https://github.com/kewalb/dad-joke",
        desc: "Dad-Joke App",
        summary: "An application which displays a bunch of dad jokes fetched from an api where a user can vote for a joke and rank it.",
        tech: "React | Material UI | Axios"
    },

    {
        image: GoogleDrive,
        link: "https://620a95dbb88ec60007fe457d--peaceful-cray-e7217f.netlify.app",
        githublink: "https://github.com/kewalb/googledrive-frontend",
        desc: "Drive Clone",
        summary: "An application where you can upload files of various types and create folders.",
        tech: "React | Material UI | Amazon S3 | Mongo DB | Node"
    }


]

export default portfolioData